exports = module.exports = require("./../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".PostList{max-width:1100px;margin:auto}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/less-loader!./src/components/PostList/PostList.less
 ** module id = 178
 ** module chunks = 0
 **/